export default __webpack_public_path__ + "locales/sk/InfoPanel.json?hash=6a0758454a5c21b2b58d8314a16a5a5c";